var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper is-fluid"},[_c('MenuBar',[_c('BookmarksFilterBar',{attrs:{"selected-tags":_vm.selectedTags}})],1),(!_vm.user.isNew)?[_c('BookmarksList')]:[_c('InfoPanel')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }